import { IQuestionnaire } from '@nocode/types';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

type QuestionMarkerProps = {
  questionMarker: string;
  index: number;
  styleConfig: IQuestionnaire['style'];
};

const QuestionMarker: React.FC<QuestionMarkerProps> = ({
  questionMarker,
  index,
  styleConfig,
}) => {
  const style = createStyle(styleConfig);
  const paddingHorizontal =
    (styleConfig.textAlign !== 'center' &&
      !styleConfig.questionMarker?.borderWidth) ||
    questionMarker === 'Q' ||
    questionMarker === '問'
      ? 0
      : 16;

  return (
    <View
      style={[
        style.questionMarkerWrapper,
        {
          paddingHorizontal,
        },
      ]}
    >
      <Text style={style.questionMarkerText}>
        {questionMarker && questionMarker.length > 0 ? questionMarker : 'Q'}
        {questionMarker && questionMarker.length > 1 ? ' ' : ''}
        {index + 1}
      </Text>
    </View>
  );
};

const createStyle = (style: any) => {
  return StyleSheet.create({
    questionMarkerWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 20,
      backgroundColor: style.questionMarker?.backgroundColor || '#0175FF',
      borderRadius: style.questionMarker?.borderRadius || 0,
      borderColor: style.questionMarker?.borderColor,
      borderWidth: style.questionMarker?.borderWidth,
      borderStyle: style.questionMarker?.borderStyle,
      minWidth: style.questionMarker?.size?.width || 40,
      height: style.questionMarker?.size?.height || 40,
    },
    questionMarkerText: {
      color: style.questionMarker?.color || '#ffffff',
      fontSize: style.questionMarker?.fontSize || 16,
      fontWeight: '700',
      fontFamily: style.fontFamily,
    },
  });
};

export default QuestionMarker;
